import styled from 'styled-components'

export const Wrapper = styled.div`
    padding: 1rem 0.6rem;
`
